module.exports = __webpack_public_path__ + "img/HG0001.c89aad9.jpg";